import * as api from '../../../api'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { ALERT } from '../../../constants/actionTypes'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import Project from '../Project/Project'

const Ongoing = ({ user, setUser, section }) => {
    dayjs.extend(relativeTime)
    const dispatch = useDispatch()
    const [quotes, setQuotes] = useState([])
    const [loading, setLoading] = useState(true)
    const [quote, setQuote] = useState({})
    const [showProject, setShowProject] = useState(false)

    const getQuotes = useCallback(async () => {
        if(!user) return false        
        if (user && !user.workPlace) setLoading(false)
        if(user.workPlace) {
            try {
                const { data } = await api.getProjects(user.workPlace.ongoing_projects)
                setQuotes(data)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
                else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
            }
        }
    }, [user, dispatch])

    const handleClick = (quote) => {
        setQuote(quote)
        setShowProject(true)
    }

    useEffect(() => {
        if(quotes.length === 0) getQuotes()
        else setLoading(false)
    }, [getQuotes, quotes])
    
    useEffect(() => {
        if(showProject) {
            document.getElementsByTagName("BODY")[0].style.overflow = 'hidden'
        } else {
            document.getElementsByTagName("BODY")[0].style.overflow = 'auto'
        }
    }, [showProject])

    return (
        <>
        {showProject && <Project showProject={showProject} setShowProject={setShowProject} quote={quote} user={user} setUser={setUser} section={section} />}
        <div className="pending">
            <h2 className="mb-40 py-20 font-subhead">
                ONGOING PROGECTS
            </h2>
            <div className="translator__scroll__ctn">
                <div className="translator__scroll__1024 d-flex w-100 mb-40">
                    <span className="admin__serial font-bold">S/N</span>
                    <div className="grid c-6 w-90 px-10">
                        <span className="font-bold">Project Name</span>
                        <span className="font-bold">Subject</span>
                        <span className="font-bold">Delivered On</span>
                        <span className="font-bold">Quantity</span>
                        <span className="font-bold">Price</span>
                    </div>
                </div>
                {loading ?
                    <div className="loader mx-auto">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                        :
                    <>
                    {quotes.length < 1 && <div className="font-bolder font-bigger text-center">No ongoing project</div>} 
                    {quotes.map((quote, index) =>
                        <div className="admin__projects translator__scroll__1024 d-flex align-center pointer" key={quote.projectName.concat(index)}>
                            <span className="admin__serial font-bold">{index + 1}</span>
                            <div className="grid align-center c-6 w-90 p-10 my-10 rounded box-shadow-lg">
                                <span title={quote.projectName} className="ellipsis pr-10">{quote.projectName}</span>
                                <span title={quote.subject} className="text-uppercase ellipsis pr-10">{quote.subject}</span>
                                <span title={dayjs(quote.reviewDate).format("dddd, MMMM D YYYY")}>{dayjs(quote.reviewDate).fromNow()}</span>
                                <span title={quote.totalPages ? `${quote.totalPages} ${quote.totalPages > 1 ? 'pages' : 'page'}` : `${quote.totalCount} words`}>
                                    {quote.totalPages ? `${quote.totalPages} ${quote.totalPages > 1 ? 'pages' : 'page'}` : `${quote.totalCount} words`}
                                </span>
                                <span title={`$ ${quote.contributors.filter(contributor => contributor.translator.email === user?.email)[0]?.amount}`}>
                                    $ {quote.contributors.filter(contributor => contributor.translator.email === user?.email)[0]?.amount}
                                </span>
                                <div className="d-flex justify-center">
                                    <button className="border-0 outline-0 w-75 font-bold rounded" onClick={() => handleClick(quote)}>
                                        Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    </>
                }
            </div>
        </div>
        </>
    )
}

export default Ongoing
